import { inject, signal } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';

export const AuthGuard: CanActivateFn = (): Observable<boolean | UrlTree> | boolean | UrlTree => {
  const router = inject(Router);
  let token = signal(localStorage.getItem('token'));

  return toObservable(token).pipe(
    map((user) => {
      if (!user) {
        return router.createUrlTree(['/auth']);
      }
      return true;
    }),
  );
};
